import * as React from 'react';
import { useEffect } from 'react';

import { useLocation } from 'js/lib/useRouter';
import { isAuthenticatedUser } from 'js/lib/user';

import OnboardingPageControls from 'bundles/onboarding-2022/components/survey/OnboardingPageControls';
import { PATHWAYS_ONBOARDING_EVENT_NAME } from 'bundles/onboarding-common/constants';
import useBuildOnboardingUrl from 'bundles/onboarding-common/hooks/useBuildOnboardingUrl';
import useSetOnboardingSeen from 'bundles/onboarding-common/hooks/useSetOnboardingSeen';
import { showPathwaysUserBased } from 'bundles/unified-common/utils/showPathways';

const OnboardingPageDelegator = () => {
  const location = useLocation();
  const { setOnboardingSeen } = useSetOnboardingSeen(
    showPathwaysUserBased() ? PATHWAYS_ONBOARDING_EVENT_NAME : 'onboarding_consumer_multi_page_2022'
  );
  const { loading, onboardingUrl } = useBuildOnboardingUrl({
    isFirstTimeSeeingOnboarding: Boolean(location.query.isFirstTimeSeeingOnboarding),
    existingLearner: Boolean(location.query.existingLearner),
  });

  useEffect(() => {
    if ((showPathwaysUserBased() || !isAuthenticatedUser()) && !loading) {
      window.location.assign(onboardingUrl);
    }
  }, [onboardingUrl, loading]);

  useEffect(() => {
    if (isAuthenticatedUser()) {
      setOnboardingSeen();
    }
  }, [setOnboardingSeen]);

  return <OnboardingPageControls />;
};

export default OnboardingPageDelegator;
